<template>
  <div class="users">
    <EntityList
      v-bind:endpoint="'api/users'"
      v-bind:filters="`?roles=ROLE_USER&customer.id=${id}`"
      v-bind:entity="userEntity"
      v-bind:editAllowedFields="['email']"
      v-bind:notDisplayedFields="['id', 'password', 'customer']"
      v-bind:removeFromPayload="['password']"
      v-bind:addLinkToDetails="false"
      v-bind:defaultValues="{ customer: `/api/customers/${this.id}`, roles:  this.$store.state.userPermissions.user}"
      v-bind:enableSearch="true"
      v-bind:searchFields="[{ text: 'Email', value: 'email' }]"/>
  </div>
</template>

<script>
import EntityList from '../EntityList/EntityList.vue';
import UserEntity from '../../store/entity/User';

export default {
  name: 'CustomerDetailsUsers',
  components: { EntityList },
  data() {
    return {
      userEntity: UserEntity,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    loadCustomerName() {
      this.$http.get(`/api/customers/${this.id}`).then((response) => {
        this.$store.commit('setCustomPageTitle', `Users for ${response.data.name}`);
      });
    },
  },
  mounted() {
    this.$store.state.showCdLinks = true;
  },
  created() {
    this.loadCustomerName();
  },
  destroyed() {
    this.$store.state.showCdLinks = false;
    this.$store.commit('clearCustomPageTitle');
  },
};
</script>

<style scoped>

</style>
